module.exports = __webpack_public_path__ + "static/img/btbz.1ff95eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btbz.png
// module id = wOtm
// module chunks = 0